import PropTypes from "prop-types"
import { compact, map, capitalize, size, lastIndexOf } from "lodash"
import { Select, MenuItem } from "@mui/material"
import Tooltip from "components/material/tooltip"

export default function BasketTypes({ longOrShortInstrument, ...props }) {
  const basketTypes = compact([
    longOrShortInstrument !== "LONG_ONLY" && "long",
    longOrShortInstrument !== "SHORT_ONLY" && "short",
  ])

  let title
  if (longOrShortInstrument !== "LONG_SHORT") {
    const unsupportedType = longOrShortInstrument.substr(0, lastIndexOf(longOrShortInstrument, "_"))
    title = `We do not support ${unsupportedType} baskets for ${unsupportedType} only portfolios`
  }

  const component = <Select variant="standard" {...props} disabled={size(basketTypes) === 1}>
    {map(basketTypes, (type) => <MenuItem key={type} value={type}>{capitalize(type)}</MenuItem>)}
  </Select>

  if (title) {
    return <Tooltip title={title}>
      {component}
    </Tooltip>
  }

  return component
}

BasketTypes.propTypes = {
  longOrShortInstrument: PropTypes.oneOf(["LONG_ONLY", "SHORT_ONLY", "LONG_SHORT"]),
}
